"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Logo = _interopRequireDefault(require("./Logo/Logo"));

var _Title = _interopRequireDefault(require("./Title/Title"));

var _Content = _interopRequireDefault(require("./Content/Content"));

require("./Header.css");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["style", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Header to be shown in the application.
 * The Header can include one or more of child elements:
 * <ul>
 *  <li>&lt;Header.Logo&gt;: Show the application Logo</li>
 *  <li>&lt;Header.Title&gt;: Show the application title</li>
 *  <li>&lt;Header.Content&gt;:Used to include any controls you want</li>
 * </ul>
 * On this documentation you can find the description of these child elements;
 */
var Header = function Header(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? null : _ref$style,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    className: "rolext-header-container",
    style: style
  }, otherProps), {}, {
    children: children
  }));
};

Header.propTypes = {
  /**
   * A CSS Style to render the Header
   */
  style: _propTypes.default.object,

  /**
   * The children nodes of the header:
   * &lt;Header.Logo&gt;, &lt;Header.Title&gt;, &lt;Header.Content&gt;.
   */
  children: _propTypes.default.node.isRequired
};
Header.Logo = _Logo.default;
Header.Title = _Title.default;
Header.Content = _Content.default;
var _default = Header;
exports.default = _default;